export const PARTIAL_HISTOGRAMS_RELEASE_DATE = new Date('2024/08/05');

export const AVG_SPEED_HISTOGRAM_RELEASE_DATE = new Date('2023/12/13');

export const SELECTED_LINK_TRIMS_INFO_RELEASE_DATE = new Date('2024/11/27');
